module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "u-relative u-flex u-flex-ai--center u-fit"
  }, [_c('div', {
    staticClass: "c-home-slide--4__right-side c-home-slide__element has-delay-2 u-absolute u-pos-tr u-zindex--3 u-fit-h",
    style: ({
      width: _vm.headerWidthAndOffset + 'px'
    })
  }, [_c('div', {
    staticClass: "c-home-slide--4__right-side__prac-earned-container js-prac-earned-container u-absolute u-flex u-flex-fd--column u-flex-ai--stretch u-flex-jc--center t-ffamily--simplon"
  }, [_c('div', {
    staticClass: "c-home-slide--4__right-side__prac-earned-container__left u-relative t-ffamily--simplon t-fweight--bold t-fsize--sm u-uppercase u-color--white"
  }, [_vm._v("\n                Earned:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--4__right-side__prac-earned-container__text u-flex u-flex-ai--start t-ffamily--simplon u-color--white"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.pracsEarned) + "\n                ")]), _vm._v(" "), _c('app-icon', {
    staticClass: "c-home-slide--4__right-side__prac-earned-container__text__icon u-fill--white u-stroke--white",
    attrs: {
      "name": "icon-logotype--stroked",
      "width": "20px"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--4__right-side__get-map-container u-absolute u-flex u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._onClickOnGetMap()
      }
    }
  }, [_c('div', {
    staticClass: "c-home-slide--4__right-side__get-map-container__left u-flex u-flex-ai--center u-flex-jc--center t-ffamily--simplon u-color--white u-uppercase"
  }, [_vm._v("\n                " + _vm._s(_vm.pracsPrice) + " PRAX\n            ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--4__right-side__get-map-container__right u-relative u-overflow-h"
  }, [_c('app-icon', {
    staticClass: "c-home-slide--4__right-side__get-map-container__arrow--1 u-absolute u-fill--white u-stroke--white",
    attrs: {
      "name": "icon-arrow--right.png"
    }
  }), _vm._v(" "), _c('app-icon', {
    staticClass: "c-home-slide--4__right-side__get-map-container__arrow--2 u-absolute u-fill--white u-stroke--white",
    attrs: {
      "name": "icon-arrow--right.png"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--4__container u-relative u-marg-x-auto u-zindex--2 u-flex u-w10of12"
  }, [_c('div', {
    staticClass: "c-home-slide--4__container__wrapper u-marg-l-w1of12 u-w1of2 u-marg-l-0@lg"
  }, [_c('app-home-slide-nb-title', {
    staticClass: "c-home-slide__element has-delay-0",
    attrs: {
      "index": 4,
      "number": "04",
      "label": "Use prax",
      "color": "black"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "c-home-slide--4__title c-home-slide__element has-delay-1 u-color--black-near t-fweight--light u-lheight--125p"
  }, [_c('div', {
    staticClass: "c-home-slide--4__title--1 u-absolute u-pos-tl",
    class: [_vm.currentLevel === 1 || _vm.currentLevel === 2 ? 'is-active' : 'is-left']
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--4__title--2 u-absolute u-pos-tl",
    class: [_vm.currentLevel === 3 ? 'is-active' : 'is-right']
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--4__slides c-home-slide__element has-delay-2 u-relative u-fit-w u-force-3d",
    class: ['is-coming-from-' + _vm.comingFromPosition, 'is-level-' + _vm.currentLevel]
  }, [_c('div', {
    staticClass: "c-home-slide--4__slides__slide c-home-slide--4__slides__slide--1 o-content u-lheight--150p u-color--black js-home-slide--4-slide u-absolute u-flex u-fit-w",
    class: [_vm.activeLevel === 1 || _vm.activeLevel === 2 ? 'is-active' : '', _vm.activeLevel === 3 ? 'is-right' : '']
  }, [_vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--4__slides__slide c-home-slide--4__slides__slide--2 o-content u-lheight--150p u-color--black js-home-slide--4-slide u-absolute u-flex u-fit-w",
    class: [_vm.activeLevel === 1 || _vm.activeLevel === 2 ? 'is-right' : '', _vm.activeLevel === 3 ? 'is-active' : '']
  }, [_vm._m(5), _vm._v(" "), _vm._m(6)])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--4__right-side__get-map-container__middle u-flex u-flex-ai--center u-flex-jc--start"
  }, [_c('span', {
    staticClass: "t-ffamily--simplon u-color--white u-uppercase"
  }, [_vm._v("Download this map")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--4__title--1 u-relative"
  }, [_vm._v("Uses for "), _c('span', {
    staticClass: "u-color--brand-primary"
  }, [_vm._v("everyone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--4__title--1 u-relative"
  }, [_vm._v("Enabling elegance and "), _c('span', {
    staticClass: "u-color--brand-primary"
  }, [_vm._v("beauty")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--4__slides__slide__title-container u-w4of12"
  }, [_c('h3', {
    staticClass: "u-flex"
  }, [_c('span', {
    staticClass: "u-color--gray-darker u-opacity--30"
  }, [_vm._v("01")]), _vm._v(" "), _c('span', {
    staticClass: "c-home-slide--4__slides__slide__title-container__title u-marg-l-w1of12 u-w9of12 t-fweight--semi-bold u-color--gray-darker"
  }, [_vm._v("Continuous Map Access")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--4__slides__slide__description-container u-marg-l-w1of12 u-w7of12"
  }, [_c('p', [_c('span', {
    staticClass: "u-opacity--40"
  }, [_vm._v("In mixed reality, apps require 3D maps. We learned that it takes one (1) hour per 5500 sqft of floor space. That's 30 minutes for the average US home, or over 400 hours for a large stadium. PRAX enable continuous access to maps, meaning people can jump straight into their chosen application instead of taking time to map. ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--4__slides__slide__title-container u-w4of12"
  }, [_c('h3', {
    staticClass: "u-flex"
  }, [_c('span', {
    staticClass: "u-color--gray-darker u-opacity--30"
  }, [_vm._v("02")]), _vm._v(" "), _c('span', {
    staticClass: "c-home-slide--4__slides__slide__title-container__title u-marg-l-w1of12 u-w9of12 t-fweight--semi-bold u-color--gray-darker"
  }, [_vm._v("Time & Persistence")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--4__slides__slide__description-container u-marg-l-w1of12 u-w7of12"
  }, [_c('p', [_c('span', {
    staticClass: "u-opacity--40"
  }, [_vm._v("Practical will have a variety of time based services that require PRAX for operation. PRAX for persistence will allow holograms to come in and out of existence, aligning mixed reality towards elegance and beauty.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b183f88a"}!./src/scripts/components/app-home-slide-4/template.html
// module id = 478
// module chunks = 0